import React from "react";
import { IFooterLinksProps } from "./FooterLinksProps";
import { Container, LinkGroup } from "./FooterLinksHelpers";
import Row from "../../../global/Row/Row";
import Col from "../../../global/Col/Col";
import { rowFooterLinks } from "./FooterLinks.module.scss";
import { useMobileDetectContext } from "../../../../context/MobileDetectContext";

const FooterLinks: React.FC<IFooterLinksProps> = (props) => {
  const [showStay, setShowStay] = React.useState(false);
  const [showWebsite, setShowWebsite] = React.useState(false);
  const [showSupport, setShowSupport] = React.useState(false);
  const [showCompany, setShowCompany] = React.useState(false);
  const showArray = [showStay, showSupport, showCompany, showWebsite];
  const { isMobileOnly } = useMobileDetectContext();
  const handleShowMenu = (event: any) => {
    const menu = event.target.dataset.menu;
    switch (menu) {
      case "stay":
        setShowStay(!showStay);
        setShowWebsite(false);
        setShowCompany(false);
        setShowSupport(false);
        break;
      case "support":
        setShowSupport(!showSupport);
        setShowWebsite(false);
        setShowCompany(false);
        setShowStay(false);
        break;
      case "company":
        setShowCompany(!showCompany);
        setShowWebsite(false);
        setShowSupport(false);
        setShowStay(false);
        break;
      case "website":
        setShowWebsite(!showWebsite);
        setShowCompany(false);
        setShowSupport(false);
        setShowStay(false);
        break;
      default:
    }
  };
  const handleBookNowClick = () => {
    if (isMobileOnly) {
      props.onBookNowClick && props.onBookNowClick();
    } else {
      window.scrollTo(0, 0);
    }
  };

  return (
    <Container>
      <Row className={rowFooterLinks}>
        {Object.keys(props).map(function (key, index) {
          if (props[key].type === "paragraph__footer_item") {
            return (
              <Col
                className={`footerLinkCol footer-item${index}`}
                key={`footer-key${index}`}
              >
                <LinkGroup
                  groupLinks={props[key]}
                  handleShowMenu={handleShowMenu}
                  showMenu={showArray[key]}
                  handleBookNowClick={handleBookNowClick}
                  isMobileOnly={isMobileOnly}
                />
              </Col>
            );
          }
        })}
      </Row>
    </Container>
  );
};

export default FooterLinks;
